import { FeedbackBlock, SupportCtaChannelType } from "./wiseOwlApi";

export interface CustomerFeedbackFormValues {
  positive: boolean;
  feedback: string;
  messageId: string;
}

export interface FeedbackProps {
  block: FeedbackBlock;
}

export enum FeedbackFormFields {
  Feedback = "feedback",
}

export interface ContactSupportProps {
  isLoggedIn: boolean;
  channel: SupportCtaChannelType;
}
